import { ComponentType } from 'react'

type DynamicImportType = () => Promise<{ default: ComponentType<unknown> }>

export default async function lazyImportRetry(importFn: DynamicImportType, retries = 2, interval = 1000): Promise<{ default: ComponentType<unknown> }> {
  try {
    return await importFn()
  } catch (error) {
    if (retries) {
      new Promise(resolve => setTimeout(resolve, interval))
      return lazyImportRetry(importFn, retries - 1, interval)
    } else {
      throw error
    }
  }
}
